"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartTable = exports.ACTION_BUTTON_WIDTH = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("react");
var index_1 = __importDefault(require("../../ui/Table/index"));
var SmartTableHeader_1 = require("./SmartTableHeader");
var If_1 = require("../../hoc/If");
var SmartTableRow_1 = require("./SmartTableRow");
var Checkbox_1 = require("../../ui/Checkbox");
var useRect_1 = require("../../hooks/useRect");
var enums_1 = require("../../enums");
var utils_1 = require("./utils");
var ProductTour_1 = require("../../ui/ProductTour");
exports.ACTION_BUTTON_WIDTH = 40;
var ACTION_BUTTON_TOGGLE_WIDTH = 40;
function SmartTable(props) {
    var _a, _b, _c;
    var tableRef = (0, react_1.useRef)();
    var tableWrapperRef = (0, react_1.useRef)();
    var _d = (0, react_2.useState)([]), headers = _d[0], setHeaders = _d[1];
    var _e = (0, react_2.useState)(), leftActionOffset = _e[0], setLeftActionOffset = _e[1];
    var _f = (0, react_2.useState)(), tableViewport = _f[0], setTableViewport = _f[1];
    var _g = (0, react_2.useState)(), tableWidth = _g[0], setTableWidth = _g[1];
    var tableWrapperRect = (0, useRect_1.useRect)(tableWrapperRef);
    var tableRect = (0, useRect_1.useRect)(tableRef);
    (0, react_2.useEffect)(function () {
        setTableViewport(tableWrapperRect.width);
        var width = (0, utils_1.GetTableWidth)(headers);
        setTableWidth(width < tableWrapperRect.width ? tableWrapperRect.width : width);
        calculateLeftOffset();
    }, [tableWrapperRect, tableWrapperRef, headers]);
    (0, react_2.useEffect)(function () {
        var headers = GetSmartTableHeaders(props.colHeaders.slice(), props.actions, props.isBulkMode, props.actionsFn);
        setHeaders(headers);
    }, [props.colHeaders, props.actions, props.isBulkMode]);
    var hasHeaders = ((_a = props.colHeaders) === null || _a === void 0 ? void 0 : _a.length) > 0;
    var hasBody = ((_b = props.data) === null || _b === void 0 ? void 0 : _b.length) > 0;
    var actionsLength = 0;
    if (props.actions) {
        actionsLength = props.actions.length;
    }
    else if (props.actionsFn && hasBody) {
        actionsLength = props.actionsFn({ content: props.data[0] }).length;
    }
    var actionsWidth = actionsLength * exports.ACTION_BUTTON_WIDTH + ACTION_BUTTON_TOGGLE_WIDTH;
    var calculateLeftOffset = function () {
        if (tableViewport) {
            var wrapperOffset = tableWrapperRef.current.scrollLeft;
            var leftOffset = wrapperOffset + tableViewport - actionsWidth;
            if (leftOffset <= tableWidth - actionsWidth) {
                setLeftActionOffset(leftOffset);
            }
        }
    };
    var hasValue = function (value) {
        return value !== undefined && value !== null && value.length > 0;
    };
    var productTourSteps = [];
    var productTourPrefix = hasValue(props.productTourPrefix)
        ? "--".concat(props.productTourPrefix)
        : "";
    props.colHeaders.map(function (e, i) {
        if (hasValue(e.productTourText)) {
            productTourSteps.push({
                target: "[data-tourid=product-tour".concat(productTourPrefix, "--").concat(e.id.replace(".", "_"), "]"),
                content: e.productTourText
            });
        }
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: tableWrapperRef, onScroll: calculateLeftOffset, className: "smart-table__wrapper" }, { children: [(0, jsx_runtime_1.jsxs)(index_1.default.Table, __assign({}, props.tableProps, { style: { width: tableWidth }, setRef: tableRef, className: "".concat(((_c = props.tableProps) === null || _c === void 0 ? void 0 : _c.className) || "", " smart-table ").concat(props.isAccordion ? "smart-table--accordion" : "") }, { children: [(0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: hasHeaders }, { children: (0, jsx_runtime_1.jsx)(SmartTableHeader_1.SmartTableHeaderGroup, { headers: headers, productTourPrefix: props.productTourPrefix }) })), (0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: hasBody }, { children: (0, jsx_runtime_1.jsx)(index_1.default.Body, __assign({ style: { maxHeight: props.height || "auto" } }, { children: props.data.map(function (row, i) {
                                return ((0, jsx_runtime_1.jsx)(SmartTableRow_1.SmartTableRow, { actions: props.actions, content: row, index: i, actionOffset: leftActionOffset, headers: headers, setIsChecked: function (value) { }, isBulkMode: props.isBulkMode, isAccordion: props.isAccordion, actionsFn: props.actionsFn, onRowClick: props.onRowClick, renderAccordionContent: props.renderAccordionContent }, i));
                            }) })) }))] })), (0, jsx_runtime_1.jsx)(ProductTour_1.ProductTour, { steps: productTourSteps, showTour: props.showProductTour || false })] })));
}
exports.SmartTable = SmartTable;
// const ForwardRef = React.forwardRef<HTMLDivElement>((props, ref)=> {
//   return <T.Table {...props} ref={ref}>
//     {props.children}
//   </T.Table>
// })
var GetSmartTableHeaders = function (headers, actions, isBulkMode, actionsFn) {
    if ((actions &&
        actions.length > 0 &&
        headers[headers.length - 1].id != "actions") ||
        (actionsFn !== null && typeof actionsFn !== "undefined")) {
        headers.push({
            id: "actions",
            content: "",
            selector: "actions",
            columnWidthSize: enums_1.UiSizes.XXS
        });
    }
    if (isBulkMode && headers[0].id != "checkbox") {
        headers.unshift({
            id: "checkbox",
            content: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { className: "smart-table__input" }),
            selector: "checkbox",
            columnWidthSize: enums_1.UiSizes.XXS
        });
    }
    return headers;
};
